export default __webpack_public_path__ + "static/media/option-2.2f23ad58.svg";